// extracted by mini-css-extract-plugin
module.exports = {"subject":"geC4KgQ6","header":"ML7qlQIy","title":"__7Rupq59R","list":"j4lRQicE","card":"CQ4mkGH4","img":"FQf8jJM_","content":"iTqllGbu","subtitle":"__4N1hnQKl"};